import { configureStore } from "@reduxjs/toolkit";
import appStateSlice from "./features/appStateSlice";
import transactionsSlice from "./features/transactionsSlice";
import userDetailsSlice from "./features/userDetailsSlice";
import clientDetailsSlice from "./features/clientDetailsSlice";
import partnershipsSlice from "./features/partnershipsSlice";
import accountSlice from "./features/accountSlice";
import userSlice from "./features/userSlice";
import clientSlice from "./features/clientSlice";
import booksSlice from "./features/booksSlice";
import reconcileSlice from "./features/reconcileSlice";
import loanSlice from "./features/loanSlice";
import clientTransactionsSlice from "./features/clientTransactionSlice";

export const store = configureStore({
  reducer: {
    appState: appStateSlice,
    transactionDetailsState: transactionsSlice,
    userDetails: userDetailsSlice,
    clientDetails: clientDetailsSlice,
    partnershipsState: partnershipsSlice,
    accountsState: accountSlice,
    userState: userSlice,
    clientState: clientSlice,
    bookState: booksSlice,
    reconcileState: reconcileSlice,
    loanState: loanSlice,
    clientTransactionsState: clientTransactionsSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
